import React from 'react'
import clsx from 'clsx'

import AllConversationsIcon from '../../../../components/icons/AllConversationsIcon'
import TransferConversationIcon from '../../../../components/icons/TransferConversationIcon'
import OfflineConversationIcon from '../../../../components/icons/OfflineConversationsIcon'

import MediaAvatar from '../../../../components/atoms/MediaAvatar'
import SelectedRectangle from '../../../../components/atoms/SelectedItemRectangle'
import NewCount from '../../../../components/molecules/BaseConversation/NewCount'

import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import {
  selectConvo,
  setTopFilter,
  TOP_FILTERS
} from '../../../../slices/convo'
import { useEnvironment } from '../../../../providers/EnvironmentProvider'
import useStyles from './styles'

const countUnreads = (cache: { [x: string]: any }, filter: string) => {
  if (!(filter in cache)) {
    return 0
  }

  let count = 0
  Object.values(cache[filter]).forEach(inbox => {
    Object.values(inbox).forEach(c => {
      count += c
    })
  })
  return count
}

interface TopFilterProps {
  text: string
  hideSelect?: boolean
  onClick?: () => void
  className?: string
}

const TopFilter: React.FC<TopFilterProps> = ({
  text,
  hideSelect,
  onClick,
  className
}) => {
  const dispatch = useAppDispatch()
  const { topFilter, unreadCache } = useAppSelector(selectConvo)

  const { user: currentUser } = useEnvironment()

  const isSelected = React.useMemo(
    () => !hideSelect && text === topFilter,
    [hideSelect, text, topFilter]
  )

  const classes = useStyles()

  const iconComponent = React.useMemo(() => {
    switch (text) {
      case TOP_FILTERS.ALL:
        return <AllConversationsIcon style={{ marginRight: '0.5rem' }} />
      case TOP_FILTERS.ASSIGNED_TO_ME:
        // @ts-ignore
        return <MediaAvatar user={currentUser} className={classes.avatar} />
      case TOP_FILTERS.TRANSFERS:
        return <TransferConversationIcon style={{ marginRight: '0.5rem' }} />
      case TOP_FILTERS.OFFLINE:
        return <OfflineConversationIcon style={{ marginRight: '0.5rem' }} />
    }
  }, [text, currentUser, classes.avatar])

  const count = React.useMemo(() => {
    return countUnreads(unreadCache, text)
  }, [unreadCache, text])

  const handleClick = React.useCallback(() => {
    dispatch(setTopFilter(text))
    onClick && onClick()
  }, [dispatch, text, onClick])

  return (
    <div onClick={handleClick} className={clsx(classes.menuOption, className)}>
      {isSelected && <SelectedRectangle />}

      {iconComponent}

      <label className={clsx(isSelected && classes.selected)}>{text}</label>

      {!isNaN(count) && count > 0 && (
        <NewCount count={count} dontGroup className={classes.pushLeft} />
      )}
    </div>
  )
}

export default TopFilter
